// Hook dodania komentarza klienta do oferty - POST /sales-crm/my-offers/:id/comments

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

export interface IPostSalesCrmMyOfferCommentPayload {
  comment: string | null;
  fileBase64?: string | null;
  fileName?: string | null;
}

const postSalesCrmMyOfferComment = (
  offerId: string | number,
  payload: IPostSalesCrmMyOfferCommentPayload
): Promise<ICommandResponseSuccess> =>
  axios.post(`/sales-crm/my-offers/${offerId}/comments`, payload);

export const usePostSalesCrmMyOfferComment = (
  offerId: string | number,
  options?: UseMutationOptions<
    ICommandResponseSuccess,
    IError,
    IPostSalesCrmMyOfferCommentPayload
  >
) =>
  useMutation(
    (payload: IPostSalesCrmMyOfferCommentPayload) =>
      postSalesCrmMyOfferComment(offerId, payload),
    options
  );
